import React from 'react';
import Form from '../Form/Form.js';
import { HeroStyles } from './Hero.styled';

const Hero = () => (
    <HeroStyles>
        <div className="hero-image">
            <h1>Find&nbsp;your dream&nbsp;home.</h1>
            <div className="form-container">
                <h2>Your search<br />starts here...</h2>
                <div className="form-content">
                    <Form />
                </div>
            </div>
        </div>
    </HeroStyles>
);

export default Hero;